module.exports = __webpack_public_path__ + "img/logo.763aed7d.png";